import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles({
  fullWidth: {
    width: '100%',
  },
  dialogSubTitle: {
    fontFamily: 'Montserrat',
    fontWeight: 700,
    fontSize: '16px',
    lineHeight: '20px',
    letterSpacing: 0,
  },
  iconUploadContainer: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
  },
  iconUploadButton: {
    paddingTop: '12px !important',
    paddingBottom: '10px !important',
  },
  iconUploadPreviewContainer: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    paddingLeft: 15,
  },
  outlinedMultiSelect: {
    paddingTop: '10px',
    '& .dropdown-container': {
      border: 'none',
      position: 'relative',
      paddingTop: '6px',
      paddingBottom: '7px',
      '&:before': {
        content: '""',
        position: 'absolute',
        left: 0,
        right: 0,
        bottom: 0,
        borderBottom: '1px solid rgba(0, 0, 0, 0.42)',
        transition: 'border-bottom-color 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
        pointerEvents: 'none',
      },
      '&:hover:before': {
        borderBottom: '2px solid rgba(0, 0, 0, 0.87)',
      },
      '&:focus-within': {
        boxShadow: 'none !important',
      },
      '&:focus-within:before': {
        borderBottom: '2px solid rgba(0, 0, 0, 0.87)',
      },
    },
    '&.disabled': {
      opacity: 0.6,
      '& .dropdown-container': {
        '&:before': {
          borderBottom: '1px solid rgba(0, 0, 0, 0.26)',
        },
        '&:hover:before': {
          borderBottom: '1px solid rgba(0, 0, 0, 0.26)',
        },
      },
      '& .dropdown-heading-value, & .gray, & span': {
        color: 'rgba(0, 0, 0, 0.38) !important',
      },
    },
  },
  inputLabel: {
    fontFamily: 'Montserrat',
    fontWeight: 400,
    fontSize: '14px !important',
    paddingLeft: '10px',
  },
  menuItem: {
    fontFamily: 'Montserrat',
    fontSize: 14,
  },
  iconPreview: { maxWidth: 200, maxHeight: 50 },
})

export { useStyles }
